const defineIconAliases = (aliases) => aliases;
export {
  defineIconAliases as d
};
//# sourceMappingURL=define-aliases.js.map
